import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { Body1, Body5, Container, Page } from '@ui';
import { SupportEmailFull } from '@ui/SupportEmail';
import { FlatButton } from '@ui/buttons';
import { signOut } from '@services/authentication';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function BrokerageMenu() {
  const navigate = useNavigate();

  const [isSigningOut, setIsSigningOut] = React.useState(false);

  const onSignOutClick = async () => {
    setIsSigningOut(true);
    const result = await signOut(true);
    if (!result) {
      setIsSigningOut(true);
    }
  };

  const onViewTaxDocumentsClick = () => {
    navigate(ROUTES.brokerageTaxDocuments);
  };

  return (
    <PageWrapper>
      <Header noActions />
      <Body withFooter>
        <Page>
          <Container>
            <Body1 bold>Tornado is no longer offering retail brokerage or simulated trading accounts</Body1>
            <Container top={24}>
              <Body5>
                If you previously had a brokerage account and would like to access statements or tax records, please use
                the link below. You can contact us at <SupportEmailFull /> if you have any questions.
              </Body5>
            </Container>
            <Container top={24}>
              <FlatButton onClick={onViewTaxDocumentsClick}>View Brokerage Documents</FlatButton>
            </Container>
            <Container top={24}>
              {isSigningOut ? (
                <SkeletonButton disabled onClick={() => null}>
                  Signing Out...
                </SkeletonButton>
              ) : (
                <SkeletonButton onClick={onSignOutClick}>Sign Out</SkeletonButton>
              )}
            </Container>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default BrokerageMenu;
